import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const SectionHeader = ({ number, title, subtitle, children }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE }}
    className="mb-12 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
  >
    <div>
      <p className="uppercase tracking-[0.3em] text-xs font-semibold text-[#B08D26] mb-3">
        {number} / {title}
      </p>
      <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-slate-900 max-w-xl">
        {subtitle}
      </h2>
    </div>
    {children}
  </motion.div>
);
